import { render, staticRenderFns } from "./TableAuthorInfo.vue?vue&type=template&id=532eb22c&"
import script from "./TableAuthorInfo.vue?vue&type=script&lang=js&"
export * from "./TableAuthorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports